import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';
import LocalizedMessage from 'react-l10n';
import { injectStripe } from 'react-stripe-elements';
import CreditCardFormFields from '../../common/NewCreditCardFormFields';
import { createAlert } from '../../../dom/window';
import { axiosCreateCreditCardAddress } from '../../../actions/creditCardActions';
import { handleAxiosErrors } from '../../../_utils';
import {getTranslation} from "../../../lang/main";

function AccountCreditCardForm(props) {
    const { handleFormSubmission, closeForm, currentBillingAddress } = props;

    const {
        formData,
        updateFormData,
        bindUpdateFormData,
        bindUpdateFormDataNumber,
        setIsSubmitting,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {
            UseNewBillingAddress: 0,
            Country: window.localeCountry,
        },
    });
    const [isValidated, setIsValidated] = useState(false);
    const [isCreditCardValidated, setIsCreditCardValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...formData,
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        let data = JSON.parse(JSON.stringify(finalFormData));

        if (typeof currentBillingAddress.ID != 'undefined') {
            data.AddressID = currentBillingAddress.ID;
        }

        // Request Manager
        // ----------------
        // - Stripe - Request to stripe to get token and card data
        const stripeRequestHandler = props.stripe
            .createToken()
            .then((stripeResponse) => {
                const { token } = stripeResponse;
                if (token) {
                    // Parse token from Stripe
                    const stripeCard = token.card;

                    data.Token = token.id;
                    data.Number = 'x'.repeat(12) + stripeCard.last4;
                    data.ExpiryMonth = stripeCard.exp_month;
                    data.ExpiryYear = stripeCard.exp_year;
                } else {
                    createAlert({ message: getTranslation('STRIPE_CONNECT_FORM.ERROR_TOKEN') }, 'error');
                    setIsSubmitting(false);
                }
            });

        // - New Billing Address - Request to graphQL to get the new billing address ID
        const addressRequestHandler = axiosCreateCreditCardAddress(data).then(
            (addressResponse) => {
                // Update address ID to this one
                data.AddressID =
                    addressResponse.data.data.createDeliveryAddress.ID;
            }
        );

        // Now let's get into processing
        if (props.stripe) {
            // Hold all the promises needed
            let promiseKeepers = [stripeRequestHandler];
            if (formData.UseNewBillingAddress) {
                promiseKeepers.push(addressRequestHandler);
            }

            // Process the promises
            Promise.all(promiseKeepers)
                .then(() => {
                    // All good, let's submit form
                    submitForm(data, {
                        success: () => {
                            console.log(
                                'Inside success() before runnning closeForm()'
                            );
                            closeForm();
                        },
                    });
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                });
        } else {
            createAlert({ message: getTranslation('STRIPE_CONNECT_FORM.ERROR_JS_LOADED') }, 'error');
        }
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    const onFieldUpdateNumber = (e) => {
        bindUpdateFormDataNumber(e);
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        let status = !validateForm(fieldRefs);

        if (!isCreditCardValidated) {
            status = false;
        }

        setIsValidated(status);
    }, [finalFormData, isCreditCardValidated]);

    return (
        <React.Fragment>
            <form className='form form-box' onSubmit={onFormSubmit}>
                <div className='vspace vspace--small'>
                    <span className='heading heading--lv5'>
                        <LocalizedMessage id={'ADD_CREDIT_CARD'} />
                    </span>
                </div>

                <CreditCardFormFields
                    fieldRefs={fieldRefs}
                    formData={finalFormData}
                    updateFormData={updateFormData}
                    handleFormUpdate={onFieldUpdate}
                    handleFormUpdateNumber={onFieldUpdateNumber}
                    currentBillingAddress={currentBillingAddress}
                    setIsCreditCardValidated={setIsCreditCardValidated}
                    showCreditCardBillingAddressFields={false}
                />

                <div className='row row--vcenter'>
                    <div className='col-xs-6'>
                        <button
                            type='submit'
                            className={`form__submit button ${
                                !isValidated ? 'button--disabled' : ''
                            }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>
                    <div className='col-xs-6 tx-right'>
                        <button
                            type='button'
                            className='button button--transparent'
                            onClick={() => closeForm()}
                        >
                            <span>
                                <LocalizedMessage id={'CANCEL'} />
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
}

class InjectedAccountCreditCardForm extends React.Component {
    render() {
        return <AccountCreditCardForm {...this.props} />;
    }
}

export default injectStripe(InjectedAccountCreditCardForm);
